export default function ($translate) {
    return {
        KEYS: {
            ET: 'ET',
            EN: 'EN',
            LT: 'LT'
        },
        LABELS: {
            ET: $translate.instant('enums.Estonian'),
            EN: $translate.instant('enums.English'),
            LT: $translate.instant('enums.Lithuanian')
        },
        // Header language switcher only: each language in its own language, never translated
        NAMES: {
            ET: 'Eesti',
            EN: 'English',
            LT: 'Lietuvių'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/company/admin/language/index.js